/* 
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

/**
 * @getFormattedPlayerTime
 * 
 * Takes a time in seconds with decimals from react-player and converts
 * them to a displayable MM:SS format
 */
export const getFormattedPlayerTime = (timeInSeconds) => {
  const minuteFormat = timeInSeconds / 60;
  const secondsFormat = timeInSeconds % 60;
  const minutes = minuteFormat > 1 ? Math.trunc(minuteFormat) : 0;
  const seconds = secondsFormat > 0 ? Math.trunc(secondsFormat) : 0;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${formattedMinutes}:${formattedSeconds}`;
};
